import { useCallback } from 'react'

import { useNavigator } from './useNavigator'

const useNavigationHandler = path => {
  const navigator = useNavigator()
  const handler = useCallback(() => {
    navigator(path)
  }, [path, navigator])

  return handler
}

export { useNavigationHandler }
